import { _optionalChain } from '@sentry/utils/esm/buildPolyfills';
import { getCurrentHub } from '@sentry/core';
/**
 * Check whether a given request URL should be filtered out.
 */

function shouldFilterRequest(replay, url) {
  // If we enabled the `traceInternals` experiment, we want to trace everything
  if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _optionalChain([replay, 'access', function (_) {
    return _.getOptions;
  }, 'call', function (_2) {
    return _2();
  }, 'access', function (_3) {
    return _3._experiments;
  }, 'optionalAccess', function (_4) {
    return _4.traceInternals;
  }])) {
    return false;
  }

  return !_isSentryRequest(url);
}
/**
 * Checks wether a given URL belongs to the configured Sentry DSN.
 */


function _isSentryRequest(url) {
  var dsn = _optionalChain([getCurrentHub, 'call', function (_5) {
    return _5();
  }, 'access', function (_6) {
    return _6.getClient;
  }, 'call', function (_7) {
    return _7();
  }, 'optionalAccess', function (_8) {
    return _8.getDsn;
  }, 'call', function (_9) {
    return _9();
  }]);

  return dsn ? url.includes(dsn.host) : false;
}

export { shouldFilterRequest };